
import { switchDirectionsActionTypes } from '@constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = 'exact';

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case switchDirectionsActionTypes.CHANGE_DIRECTION:

            if(typeof action.direction !== 'string') {
                throw new Error('Not a string was provided as direction into directionReducer');
            }

            return action.direction;
        case switchDirectionsActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};